import React from "react";
// import Banner from 'react-js-banner';
function ApixIntroduction() {
  return (
    <div class="idocs-content">
      <div class="row">
        <div class="col-md-12">
          <div
            style={{
              color: "#fff !important",
              backgroundColor: "#263f91",
              height: "350px",
            }}
          >
            <h1 class="banner-text" style={{}}>
              Welcome
              <br />
              to Safexpay
              <br />
              Documentation
            </h1>
            <p
              style={{
                color: "#fff",
                float: "left",
                paddingLeft: "140px",
                marginTop: "10px",
              }}
            >
              Welcome to the Safexpay developer documentation. <br />
              You will find help about safexpay products and APIs <br />
              that will help you start using our products quickly.
            </p>
            <img
              src={process.env.PUBLIC_URL + "/images/Arrow-Green.png"}
              alt="logo"
              style={{
                width: "21%",
                float: "right",
                top: "5%",
                right: "20%",
                position: "absolute",
              }}
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content">
              <h1>Introduction</h1>
              <hr />
              <p className="mt-20">
                Welcome to APIX, a versatile & developer-friendly API Automated
                Collection where you can access multiple APIs under one
                platform.
              </p>
              <p>
                Our API solutions cater to many use cases, from payment to doc
                verification to banking to other utilities, we have it all.{" "}
              </p>
              <p>
                It is designed to be user-friendly, offering simplicity,
                reliability, and a developer-focused approach. We emphasize
                precision in workflow, ensuring speedy and efficient digital
                solutions. Our commitment to the latest and most secure
                technology underscores our dedication to providing cutting-edge
                solutions for you and your customers.{" "}
              </p>
              <p>
                This comprehensive portal will equip you with the knowledge and
                resources necessary to integrate and utilize our powerful API
                seamlessly.{" "}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ApixIntroduction;
